import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-194ed0af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "appBarLayout" }
const _hoisted_2 = { id: "body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_right_slider_menu = _resolveComponent("right-slider-menu")!
  const _component_right_slide_modal = _resolveComponent("right-slide-modal")!
  const _component_org_management_header = _resolveComponent("org-management-header")!
  const _component_primary_menu = _resolveComponent("primary-menu")!
  const _component_Chevrons = _resolveComponent("Chevrons")!
  const _component_collapsable_menu = _resolveComponent("collapsable-menu")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_errorhandler = _resolveComponent("errorhandler")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", null, [
      _createVNode(_component_right_slider_menu, {
        "is-menu-open": _ctx.isRightSliderMenuOpen,
        onClose: _ctx.closeRightSliderMenu
      }, null, 8, ["is-menu-open", "onClose"]),
      _createVNode(_component_right_slide_modal, {
        "is-show": _ctx.isRightSliderModalOpen,
        onShow: _ctx.handleShowRightSliderModal,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isRightSliderModalOpen = false))
      }, null, 8, ["is-show", "onShow"]),
      _createVNode(_component_org_management_header, {
        onMenuDotsClick: _ctx.handleRightMenuOpen,
        onNotificationClick: _ctx.handleNotificationOpen
      }, null, 8, ["onMenuDotsClick", "onNotificationClick"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["left-sidebar", `${_ctx.overlayLanding ? '!tw-z-[4]' : ''} tw-relative tw-flex ${
            _ctx.isMenuOpen ? '' : 'tw-z-[2]'
          } ${_ctx.zIndexMenu === 0 ? '!tw-z-[1]' : ''}`])
        }, [
          _createVNode(_component_primary_menu, {
            icons: _ctx.primaryMenuIcons,
            "is-menu-open": _ctx.isMenuOpen,
            "hover-menu-index": _ctx.hoverMenuIndex,
            onOnSelectedIconIndexChange: _ctx.onPrimaryMenuChange,
            onHoveredIcon: _ctx.openMenu,
            onUnhoveredIcon: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setIsMenuOpen(false))),
            onSetHoveredIndex: _ctx.setHoverMenuIndex,
            onSetIsMenuOpen: _ctx.setIsMenuOpen,
            onToggleMenu: _ctx.toggleMenu
          }, null, 8, ["icons", "is-menu-open", "hover-menu-index", "onOnSelectedIconIndexChange", "onHoveredIcon", "onSetHoveredIndex", "onSetIsMenuOpen", "onToggleMenu"]),
          _createElementVNode("span", {
            class: _normalizeClass(`toggleIconWrapper tw-bottom-[19px] tw-left-[2px] md:tw-left-[unset]  md:tw-top-[24px] ${
              _ctx.isMenuOpen ? 'md:tw-right-[-8px]' : 'md:tw-right-[-8px]'
            } ${_ctx.zIndexMenu === 0 ? '!tw-z-[3]' : ''} ${
              _ctx.isOverlayMainVisible && !_ctx.isChevronActive && _ctx.isMenuOpen
                ? '!tw-right-[-229px]'
                : ''
            }`),
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleClickedActive && _ctx.handleClickedActive(...args)))
          }, [
            _createVNode(_component_Chevrons, {
              class: _normalizeClass(`toggle-icon ${_ctx.isMenuOpen ? '' : 'active'}`)
            }, null, 8, ["class"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`collapsible-wrapper ${
              _ctx.isOverlayMainVisible && !_ctx.isChevronActive
                ? '!tw-absolute tw-h-[100%] tw-left-[62px]'
                : ''
            } ${_ctx.zIndexMenu === 0 ? '!tw-z-[0]' : ''}`)
          }, [
            _createVNode(_component_collapsable_menu, {
              "section-title": _ctx.primaryMenuIcons[_ctx.hoverMenuIndex]?.sectionTitle,
              "section-sub-title": 
                _ctx.primaryMenuIcons[_ctx.hoverMenuIndex]?.sectionSubTitle
              ,
              "menu-url": _ctx.primaryMenuIcons[_ctx.hoverMenuIndex]?.url,
              "menu-items": _ctx.menuItems[_ctx.hoverMenuIndex],
              "is-menu-open": _ctx.isMenuOpen,
              onSetActiveHierarchy: _ctx.setActiveHierarchy,
              onSetIsMenuOpen: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setIsMenuOpen(!_ctx.isMenuOpen)))
            }, null, 8, ["section-title", "section-sub-title", "menu-url", "menu-items", "is-menu-open", "onSetActiveHierarchy"])
          ], 2)
        ], 2),
        _createElementVNode("div", {
          id: "slot-wrapper",
          class: _normalizeClass(`main-body ${
            (_ctx.overlayLanding || _ctx.$route.path === _ctx.ROUTERS.shareProfile) &&
            _ctx.isChevronActive
              ? '!tw-overflow-visible'
              : ''
          }`)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(`${
              _ctx.isChevronActive && _ctx.isMenuOpen ? 'slot-main' : 'slot-main-full-w'
            } `)
          }, [
            _renderSlot(_ctx.$slots, "default", {
              activeHierarchy: _ctx.activeHierarchy,
              isMenuOpen: _ctx.isMenuOpen
            }, undefined, true)
          ], 2)
        ], 2),
        _createVNode(_component_Notification, {
          "is-notification-nav": _ctx.isNotificationficationOpen,
          onCloseNotification: _ctx.closeNotification
        }, null, 8, ["is-notification-nav", "onCloseNotification"]),
        _withDirectives(_createElementVNode("div", {
          class: "overlay color",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeRightSliderMenu && _ctx.closeRightSliderMenu(...args)))
        }, null, 512), [
          [_vShow, _ctx.isOverlayVisible]
        ]),
        (
            _ctx.isMenuOpen &&
            !(_ctx.isChevronActive && _ctx.hoverMenuIndex === _ctx.primaryMenuIndex)
          )
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(`overlay ${_ctx.overlayLanding ? '!tw-z-[4]' : ''} ${
            _ctx.isMenuOpen && !_ctx.isMobileView ? '!tw-left-[280px]' : ''
          }`),
              onMouseover: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hoverOnOverlay && _ctx.hoverOnOverlay(...args)))
            }, null, 34))
          : _createCommentVNode("", true),
        (_ctx.isErrorPopupOpen() || null)
          ? (_openBlock(), _createBlock(_component_errorhandler, {
              key: 1,
              "prospect-callback-error-msg": _ctx.getErrorMessage(),
              onResetShowProspectCallbackError: _ctx.onCloseErrorPopup
            }, null, 8, ["prospect-callback-error-msg", "onResetShowProspectCallbackError"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}